import {Accordion, Alert, Badge, Button, Col, Form, InputGroup, Modal, Row} from "react-bootstrap";
import {useEffect, useState} from "react";
import {useData} from "./Calendar";
import {AddressDisplay} from "../../components/AddressForm";
import {useAuth} from "../../providers/authprovider";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFileLines, faFolderOpen, faTriangleExclamation,faCalendarDay} from "@fortawesome/free-solid-svg-icons";
import Notes from "../buildings/Notes";

export default function StatusModal(props){

    const {calendar} = useAuth();

    const [states, setStates] = useState(undefined);
    const [showNotes, setShowNotes] = useState(false)
    const {event, onChangeEvent} = props;
    const { workers,shortBuildings} = useData();
    const [alert, setAlert] = useState({
        show:false,
        error:"",
    });

    const hideAlert = ()=>{setAlert({show:false, error: ""})}

    useEffect(()=>{
        if(states !== undefined)
            return;

        calendar.getEventStates(event.id, ({success,error, content})=>{
            if(error || success !== true){
                setAlert({show:true, error:error});
                return;
            }

            setStates(content);
        })
    })

    let users = [];
    if(event.users)
        users = workers.filter(w=>event.users.includes(w.id));

    function getBuildingAddress(building_id){
        const building = shortBuildings.find(b=>b.id === building_id);

        if(!building)
            return;

        return <div className={"ms-4"}><AddressDisplay address={building} /></div>
    }

    function getBuildingShortData(){
        const building = shortBuildings.find(b=>b.id === event.building_id);
        if(!building)
            return {id:"", name:""};

        return {id:building.id, name:building.name};
    }

    const handleSuccessfullAddState = (state)=>{
        if(state.event && onChangeEvent)
            onChangeEvent(state.event);

        setStates([...states, state]);
    }

    const eventInfo = ()=>{
        if(!(event.info && event.info.length > 0 ))
            return null;

        return <Alert show={true} variant={"warning"}><FontAwesomeIcon className={"fs-3 me-4"} icon={faTriangleExclamation} /><i>{event.info}</i></Alert>

    }


    return (

            <Modal
                show={props.show}
                onHide={props.onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {
                            event.type==='INSPECTION' ? "Przegląd " : "Zgłoszenie / Awaria "
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Alert show={alert.show} variant={"danger"} onClose={hideAlert} dismissible>
                        <p>
                            {alert.error}
                        </p>
                    </Alert>
                    <Row className={"pb-2"}>
                        <Col lg="1">
                            <Button variant={"outline-info"} title={"Historia obiektu"} onClick={()=>setShowNotes(true)} ><FontAwesomeIcon icon={faCalendarDay} /></Button>

                            {
                                showNotes &&
                                <Notes building={getBuildingShortData()} onHide={()=>setShowNotes(false)} />
                            }
                        </Col>
                        <Col lg="9">
                            <h6>{event.name}</h6>
                            {
                                getBuildingAddress(event.building_id)
                            }
                        </Col>
                        <Col lg="2" className={"text-end"}><b>{new Date(event.date).toLocaleDateString()}</b></Col>
                    </Row>
                    <Row className={"pb-2"}>
                        {
                            users?.map(user=>
                                <Col key={user.id}><span key={user.id} className={"userBadge"} style={{backgroundColor:user.color}} title={user.name}></span>{user.name}</Col>
                            )
                        }
                    </Row>
                    <Row>
                        <Col className={"ps-4"}>
                            {eventInfo()}
                        </Col>
                    </Row>
                    <hr/>

                    {
                        states &&
                        <>
                            <SetStateForm event={event} states={states}  onSuccessfullSend={handleSuccessfullAddState} />
                            <StateList event={event} states={states} />
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={props.onHide}>Zamknij</Button>
                </Modal.Footer>
            </Modal>

    )
}

export const STATE_DENIED = "CONFIRMATION_DENIED"

export const INSPECTION_STATES = {
    CONFIRMATION: "CONFIRMATION",
    USER_CONFIRMATION: "USER_CONFIRMATION",
    REALIZATION: "REALIZATION",
    FINISHED: "FINISHED"
}

export const MALFUNCTION_STATES = {
    CONFIRMATION:"CONFIRMATION",
    USER_CONFIRMATION:"USER_CONFIRMATION",
    REALIZATION:"REALIZATION",
    LOCAL_VISION:"LOCAL_VISION",
    OFFER:"OFFER",
    OFFER_REALIZATION:"OFFER_REALIZATION",
    FINISHED:"FINISHED"
}

function getNextState(lastState, eventType){
    let states = INSPECTION_STATES;
    if(eventType === 'MALFUNCTION')
        states = MALFUNCTION_STATES;

    const keys = Object.keys(states);

    if(lastState === undefined)
        return states[keys[0]];

    const index = keys.indexOf(lastState.name);


    if(index < 0)
        return states[keys[0]];

    if(index === keys.length-1)
        return "";

    return states[keys[index+1]];
}

function getInspectionStatesInfo(name){
    switch (name){
        case INSPECTION_STATES.CONFIRMATION:
            return {name:"Ustawienie terminu"};
        case INSPECTION_STATES.USER_CONFIRMATION:
            return {name:"Przyjęcie terminu"};
        case INSPECTION_STATES.REALIZATION:
            return {name:"Realizacja"};
        case INSPECTION_STATES.FINISHED:
            return {name:"Zakończenie"};
        case STATE_DENIED:
            return {name:"Odrzucono termin"};
        default:
            return undefined
    }
}

export function getMalfunctionStatesInfo(name){
    switch (name){
        case MALFUNCTION_STATES.CONFIRMATION:
            return {name:"Propozycja terminu"};
        case MALFUNCTION_STATES.USER_CONFIRMATION:
            return {name:"Przyjęcie terminu"};
        case MALFUNCTION_STATES.LOCAL_VISION:
            return {name:"Wizja lokalna"};
        case MALFUNCTION_STATES.REALIZATION:
            return {name:"Realizacja"};
        case MALFUNCTION_STATES.OFFER:
            return {name:"Ofertowanie"};
        case MALFUNCTION_STATES.OFFER_REALIZATION:
            return {name:"Realizacja oferty"};
        case MALFUNCTION_STATES.FINISHED:
            return {name:"Zakończenie"};
        case STATE_DENIED:
            return {name:"Odrzucono termin"};
        default:
            return undefined
    }
}

export function GetStateNamePl(nameString){
    switch(nameString){
        case "CONFIRMATION":
            return "Ustawienie terminu";
        case "USER_CONFIRMATION":
            return "Przyjęcie terminu";
        case "REALIZATION":
            return "Realizacja";
        case "FINISHED":
            return "Zakończenie";
        case "LOCAL_VISION":
            return "Wizja lokalna";
        case "OFFER":
            return "Ofertowanie";
        case "OFFER_REALIZATION":
            return "Realizacja oferty";
        case "CONFIRMATION_DENIED":
            return "Odrzucono termin";
        default:
    }
}

function StateList(props){

    const isInspection = props.event.name === 'INSPECTION';
    const states = props.states;

    const stateFactory = (state)=>{

        const body = state.body && JSON.parse(state.body);
        const info = isInspection ? getInspectionStatesInfo(state.name) : getMalfunctionStatesInfo(state.name);
        const date = new Date(state.created_at);
        const dateTime = date.toLocaleTimeString('pl-PL', {timeZone:'UTC'})+" "+date.toLocaleDateString('pl-PL', {timeZone:'UTC'});
        const userInfo = <div className={"text-end"}><small><small>Status został ustawiony o <b>{dateTime}</b> przez <b>{state.user}</b></small></small></div>;
        const description = (body.description && body.description.length > 0) && <>
                            <Form.Text  muted>
                                Dodatkowe informacje:
                            </Form.Text>
                            <Form.Control
                            as={"textarea"}
                            disabled={true}
                            defaultValue={body.description}
                        />
                    </>;
        const offerIco =(body.offer === true) ? <FontAwesomeIcon className={"text-success me-2 ms-2"} icon={faFileLines}  title={"Ofertowanie"}  /> : null;
        const offer = (body.offer === true) ? <Col><h4><Badge pill bg={"success"}><FontAwesomeIcon icon={faFileLines} /> Należy wystawić ofertę</Badge></h4></Col> : null;
        const protocolIco = (body.protocol === true) ? <FontAwesomeIcon className={"text-info me-2 ms-2"} icon={faFolderOpen} title={"Sporządzono protokół"} /> : null;
        const protocol = (body.protocol === true) ? <Col><h4><Badge pill bg={"info"}><FontAwesomeIcon icon={faFolderOpen} /> Sporządzono protokół</Badge></h4></Col> : null;
        const notAcceptedIco = (body.acceptance === "false") ? <FontAwesomeIcon className={"text-danger me-2 ms-2"} title={"Termin został odrzucony przez serwisanta"} icon={faTriangleExclamation} /> : null;
        const notAcceptedInfo = (body.acceptance === "false") ? <h6>Serwisant {state.user} odrzucił sugerowany termin przeglądu.</h6> : null;


        return <Accordion.Item key={state.i} eventKey={state.i}>
            <Accordion.Header className={`${state.name} position-relative`}>
                <b>{info.name}</b> {notAcceptedIco} {offerIco} {protocolIco}
            </Accordion.Header>
            <Accordion.Body>
                <Row>
                    {offer}
                    {protocol}
                </Row>
                {notAcceptedInfo}
                {description}
                {userInfo}
            </Accordion.Body>
        </Accordion.Item>
    }

    if(states.length <=0)
        return null;

    return (
        <Accordion defaultActiveKey={states[0].i}>
            {
                states.map(stateFactory)
            }
        </Accordion>

    )
}

function SetStateForm({event,states, onSuccessfullSend}){

    const {user} = useAuth();
    const privilege =  user.getPrivilege('calendar');

    const {calendar} = useAuth();
    const [stateData, setStateData] = useState(
        {}
    )
    function isInspection() {
        return event.type === 'INSPECTION'
    }
    const [stateName, setStateName] = useState(()=>getNextState(states[0], event.type));
    const [alert, setAlert] = useState({
        show:false,
        error:"",
    });
    const hideAlert = ()=>{setAlert({show:false, error: ""})}


    const onPickStateType = (event)=>{
        setStateName(event.target.value);
        setStateData({});
    }

    const handleChangeStateData = (event)=>{
        setStateData({...stateData, [event.target.name]:event.target.value});
    }

    const handleDateChange = (event)=>{
        let val = event.target.value;
        let time = undefined;
        if(val.length > 0)
            time =  new Date(val).getTime();
        setStateData({...stateData, date : time});
    }

    const handleChangeCheckbox = (event)=>{
        setStateData({...stateData, [event.target.name]: event.target.checked});
    }

    const handleSendStateData = (e)=>{
        const name = e.target.name;
        const value = e.target.value;

       stateData.name = stateName;

        if(name !== undefined && name.length > 0)
            stateData[name] = value;


        calendar.sendEventState(event.id, stateData,({success,error, content})=>{

            if(error || success !== true){
                setAlert({show:true, error:error});
                return;
            }
            setStateName("");
            setStateData({});
            onSuccessfullSend(content)

        })
    }

    const formTextArea = <><Form.Control
        as={"textarea"}
        rows={2}
        name={"description"}
        onChange={handleChangeStateData}
        aria-describedby="infoDesc"
    />
        <Form.Text id="infoDesc" muted>
            Wpisz dodatkowe informacje
        </Form.Text></>

    const formUserRealization = <div>

        <div className={"p-2"}>
            <Form.Check
                inline
                label="Sporządzono protokół"
                name="protocol"
                type={"checkbox"}
                onChange={handleChangeCheckbox}
                id={`inline-protocol-check`}
            />
            <Form.Check
                inline
                label="ofertowanie"
                name="offer"
                type={"checkbox"}
                onChange={handleChangeCheckbox}
                id={`inline-offer-check`}
            />
        </div>
        {formTextArea}
        <div className={"text-end"}>
            <Button variant={"success"}  onClick={handleSendStateData} >Wyślij</Button>
        </div>
    </div>

    const formUserConfirmation = <div>
        <p>
            Potwierdź lub odrzuć proponowany termin realizacji. Wprowadź stosowne informacje w poniższym polu.
        </p>
        {formTextArea}
        <Row>
            <Col>
                <Button variant={"dark"} name={"name"} value={STATE_DENIED} onClick={handleSendStateData}  >Odrzuć (inny termin)</Button>
            </Col>
            <Col className={"text-end"}>
                <Button variant={"success"}  name={"name"} value={INSPECTION_STATES.USER_CONFIRMATION}  onClick={handleSendStateData} >Potwierdź</Button>
            </Col>
        </Row>
    </div>

    const getStateForm = ()=>{

        switch (stateName){
            case INSPECTION_STATES.CONFIRMATION:
                return <div>
                    <InputGroup className="mb-3" >
                        <InputGroup.Text id="team_select">Termin </InputGroup.Text>
                        <Form.Control  onChange={handleDateChange}  type="date" name={"date"}/>
                    </InputGroup>
                    {formTextArea}
                    <div className={"text-end"}>
                        <Button variant={"success"}  onClick={handleSendStateData}  >Zatwierdź</Button>
                    </div>
                </div>
            case INSPECTION_STATES.USER_CONFIRMATION:
                return formUserConfirmation
            case INSPECTION_STATES.REALIZATION:
                return formUserRealization
            case MALFUNCTION_STATES.LOCAL_VISION:
                return <>{formTextArea}
                    <div className={"text-end"}>
                        <Button variant={"success"}  onClick={handleSendStateData} >Wyślij</Button>
                    </div></>
            case MALFUNCTION_STATES.OFFER:
                return <>{formTextArea}
                    <div className={"text-end"}>
                        <Button variant={"success"}  onClick={handleSendStateData} >Wyślij</Button>
                    </div></>
            case MALFUNCTION_STATES.OFFER_REALIZATION:
                return formUserRealization
            case INSPECTION_STATES.FINISHED:
                return <div>
                    {formTextArea}
                    <div className={"text-end"}>
                        <Button variant={"danger"}  onClick={handleSendStateData}  >Zakończono</Button>
                    </div>
                </div>

        }

        return null;
    }

    const getUserStateForm = ()=>{
        if(states.length <=0)
            return;

        if(isInspection()) {
            switch (states[0].name) {
                case INSPECTION_STATES.CONFIRMATION: //show USER_CONFIRMATION form
                    return formUserConfirmation;
                case INSPECTION_STATES.USER_CONFIRMATION: //show realization form
                    return formUserRealization;
            }
            return;
        }

        if(states[0].name === MALFUNCTION_STATES.CONFIRMATION)
            return formUserConfirmation

        //for malfunction
        return <>
            <InputGroup className="mb-3">
                <InputGroup.Text >STATUS</InputGroup.Text>
                <Form.Select aria-label="select state" name={"name"} defaultValue={stateName} onChange={onPickStateType}>
                    <option>wybierz z listy...</option>
                    {
                        ([
                            MALFUNCTION_STATES.LOCAL_VISION,
                            MALFUNCTION_STATES.REALIZATION,
                            MALFUNCTION_STATES.OFFER_REALIZATION,
                        ]).map(key=>{
                            const val = getMalfunctionStatesInfo(key);
                            return <option value={key} key={key}>{val.name}</option>
                        })
                    }
                </Form.Select>
            </InputGroup>
            {
                getStateForm()
            }
        </>

    }

    const isUserInEvent = ()=>{
        return event.users.findIndex((id)=>id === user.id) > -1;
    };

    function generateOptions(){
        let states = INSPECTION_STATES;
        if(!isInspection())
            states = MALFUNCTION_STATES;

        const keys = Object.keys(states);

        return keys.map(key=>{
            const val = isInspection() ? getInspectionStatesInfo(key) : getMalfunctionStatesInfo(key);
            if(val !== undefined)
                return <option value={key} key={key}>{val.name}</option>
        });

    }

    return (
        <div className={"border  m-2 p-2 bg-light"}>
            <Alert show={alert.show} variant={"danger"} onClose={hideAlert} dismissible>
                <p>
                    {alert.error}
                </p>
            </Alert>
            {
                privilege.edit &&
                <>
                    <h4 className={"text-center"}>NOWY STATUS</h4>
                    <InputGroup className="mb-3">
                        <InputGroup.Text >STATUS</InputGroup.Text>
                        <Form.Select aria-label="select state" name={"name"} defaultValue={stateName} onChange={onPickStateType}>
                            <option>wybierz z listy...</option>
                            {
                                generateOptions()
                            }
                        </Form.Select>
                    </InputGroup>
                    {
                        getStateForm()
                    }
                </>
            }
            {
                (!privilege.edit && isUserInEvent()) && getUserStateForm()
            }


        </div>
    )

}